<template>
    <main class="-mt-32">
        <calendar-day></calendar-day>
        <calendar-week></calendar-week>
    </main>
</template>
<script>
import CalendarDay from "./CalendarTimeLine";
import CalendarWeek from "./CalendarWeek";

export default {
    data: () => {
        return {
            appointment: {},
            showAllDay: false,
            startHour: 9,
            endHour: 19,
            hours: []
        };
    },

    components: {
        CalendarDay,
        CalendarWeek
    },

    mounted() {
        this.$store.dispatch("record/RECORDS");
    }
};
</script>
